import {DetailsForm} from "./components/DetailsForm";
import {useCurrentUser} from "_api/hooks/auth";
import {Suspense} from "react";
import FormSuspense from "_components/suspense/FormSuspense";
import {VStack} from "_ui/Box";
import {useUpdateUserProfile} from "_api/hooks/profile";
import {toastRun} from "_utils/misc";
import {toastSuccess} from "_components/ToastProvider";

const Form = () => {
    const {mutateAsync: update, isPending: loading} = useUpdateUserProfile();
    const {user: {name}} = useCurrentUser();
    const defaultValues = {
        name
    };

    const onSubmit = async (data) => {
        await toastRun(
            update(data),
            () => toastSuccess("Informações atualizadas.")
        )
    };

    return <DetailsForm {...{defaultValues, loading, onSubmit}}/>;
}

export const Details = () => {


    return (
        <VStack g={2}>
            <h3>Informações da conta</h3>
            <Suspense fallback={<FormSuspense fields={1}/>}>
                <Form/>
            </Suspense>
        </VStack>
    );
};
